/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentAccount/PaymentAccountSelect/Content",
  isInvalid
  
}) {
let paymentAccountsValueData = fromData.useDataValue({ viewPath,
context: 'payment_accounts',
})
let selectedFilterValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'filter',
})
let aggregateData = fromHelpers.filterPaymentAccounts(paymentAccountsValueData, selectedFilterValueData)
let selectedPaymentAccountSelectedIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'payment_account.selected_id',
})
let selectedPaymentAccountSelectedIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'selected',
path: 'payment_account.selected_id',
validate: fromValidate.textInputOrNumber,
required: true,
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  isInvalid
  
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 isMultiChoice={false}
 onChange={onChange}
 data="payment_accounts"
 data="selected.filter"
 aggregate="helpers.js filterPaymentAccounts"
 from={aggregateData}
 data="selected.payment_account.selected_id"
 validate="/Data/validate.js textInputOrNumber"
 required={true}
 value={selectedPaymentAccountSelectedIdValueData}
 invalid={!selectedPaymentAccountSelectedIdIsValidData}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}